import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import Table, {
  dateFormatter,
  buttonsStyle,
} from "../../../components/tables/table";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import {
  getCursos,
  deleteCurso,
  changeStatusCurso,
  changeOrderCurso,
  changeStatusRegistroCurso,
  duplicarCurso,
  changeVisibleCurso,
} from "../../../../api/curso";
import {
  Button,
  Tooltip,
  Switch,
  FormControlLabel,
  TextField,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import AddIcon from "@material-ui/icons/Add";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { useHistory } from "react-router-dom";
import ToggleOffIcon from "@material-ui/icons/ToggleOff";
import ToggleOnIcon from "@material-ui/icons/ToggleOn";
import { shallowEqual, useSelector } from "react-redux";
import FiltersCard from "../../../components/filters/Filter";
import {
  KeyboardArrowDown,
  KeyboardArrowUp,
  Lock,
  LockOpen,
} from "@material-ui/icons";
import { Copy, Eye, EyeClosed } from "lucide-react";
import Select from "react-select";
import SearchIcon from "@material-ui/icons/Search";
import { Autorenew as FilterOffIcon } from "@material-ui/icons";

function getData(cursos) {
  let data = [];
  for (let i = 0; i < cursos.length; ++i) {
    // Excluir formaciones continuas personalizadas de la vista de "Cursos"
    if (cursos[i]?.tipoCurso === "continua_personalizada") continue;

    const elem = {};
    elem.titulo = cursos[i].titulo["es"];
    elem.order = cursos[i].order;
    elem.imageURL = cursos[i].imageURL;
    elem.code = cursos[i].code;
    elem.nRegistro = cursos[i].nRegistro;
    // Formatear créditos: mostrar "0 (pendiente)" si no están definidos y el valor es 0
    const creditosDefinidos = cursos[i].creditosDefinidos !== false; // default true
    if (!creditosDefinidos) {
      elem.creditos = "En trámite";
    } else {
      elem.creditos = cursos[i].creditos;
    }
    elem.fechaIni = cursos[i].fechaIni;
    elem.fechaFin = cursos[i].fechaFin;
    elem.desc = cursos[i].desc;
    elem.visible = cursos[i].visible || false;
    elem.isZoom = cursos[i].isZoom || false; // Para filtro Zoom
    elem.createdAt = cursos[i].createdAt;
    elem.id = cursos[i]._id;
    elem.active = cursos[i].active;
    // Calcular plazas libres
    const inscripcionesActivas = cursos[i].inscripciones
      ? cursos[i].inscripciones.filter((insc) => insc.active !== false).length
      : 0;
    const maxPlazas = cursos[i].maxPlazas || cursos[i].plazas || null;
    const cursoCompleto = cursos[i].cursoCompleto || false;

    // Si está marcado como completo, mostrar "Completo"
    if (cursoCompleto) {
      elem.plazasLibres = "Completo";
    } else if (maxPlazas !== null && maxPlazas !== undefined) {
      const plazasLibres = maxPlazas - inscripcionesActivas;
      elem.plazasLibres =
        plazasLibres > 0 ? `${plazasLibres} plazas libres` : "Completo";
    } else {
      // Si no hay límite de plazas, mostrar solo el número de inscripciones
      elem.plazasLibres = `${inscripcionesActivas} inscripciones`;
    }
    elem.inscripcionesActivas = inscripcionesActivas;
    elem.maxPlazas = maxPlazas;
    elem.cursoCompleto = cursoCompleto;
    data = data.concat(elem);
  }
  // Orden descendente: mayor order primero (subir = +1, bajar = -1)
  data.sort((a, b) => b.order - a.order);
  return data;
}

const initialFilters = {
  active: false,
  fechaIniDesde: "",
  fechaIniHasta: "",
  isZoom: null, // null = todos, true = solo Zoom, false = solo no Zoom
};

export default function CursosPage() {
  const [data, setData] = useState([]);
  const [cursoId, setCursoId] = useState(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [collapsed, setCollapsed] = useState(true);
  // Cargar filtros desde localStorage al iniciar
  const [filterOptions, setFilterOptions] = useState(() => {
    const savedFilters = localStorage.getItem("cursosPageFilters");
    return savedFilters ? JSON.parse(savedFilters) : initialFilters;
  });
  // Estado para el campo de búsqueda
  const [searchText, setSearchText] = useState(() => {
    const saved = localStorage.getItem("cursosPage_searchText");
    return saved || "";
  });
  const history = useHistory();

  // Handler para actualizar la búsqueda (se usa tanto desde el TextField como desde el Table)
  const handleTableSearchChange = React.useCallback((value) => {
    const trimmedValue = value ? value : "";
    setSearchText(trimmedValue);
    if (trimmedValue) {
      localStorage.setItem("cursosPage_searchText", trimmedValue);
    } else {
      localStorage.removeItem("cursosPage_searchText");
    }
  }, []);
  const user = useSelector((store) => store.authentication?.user, shallowEqual);

  const handleChangeOrder = (id, up) => {
    changeOrderCurso(id, up)
      .then((res) => {
        setRefresh(true);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  function buttonFormatter(cell) {
    const elem = data.find((item) => item._id === cell);
    const displayed = filteredData.length ? filteredData : data;
    const maxOrder = displayed.length ? Math.max(...displayed.map((d) => d.order ?? 0)) : 0;
    const minOrder = displayed.length ? Math.min(...displayed.map((d) => d.order ?? 0)) : 0;
    const isFirst = elem?.order === maxOrder;
    const isLast = elem?.order === minOrder;
    return (
      <>
        {(user?.role === "admin" || user.role === "consultor") && (
          <>
            {user.role === "admin" && (
              <>
                <Tooltip title={"Subir (sumar 1)"}>
                  <Button
                    style={buttonsStyle}
                    size="small"
                    onClick={() => handleChangeOrder(cell, true)}
                    disabled={isFirst}
                  >
                    <KeyboardArrowUp />
                  </Button>
                </Tooltip>
                <Tooltip title={"Bajar (restar 1)"}>
                  <Button
                    style={buttonsStyle}
                    size="small"
                    onClick={() => handleChangeOrder(cell, false)}
                    disabled={isLast}
                  >
                    <KeyboardArrowDown />
                  </Button>
                </Tooltip>
              </>
            )}
            <Tooltip title="Edit">
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => {
                  // Guardar filtros actuales antes de navegar
                  localStorage.setItem(
                    "cursosPageFilters",
                    JSON.stringify(filterOptions),
                  );
                  history.push("/edit-curso/" + cell);
                }}
              >
                <EditIcon />
              </Button>
            </Tooltip>
            {user.role === "admin" && (
              <>
                <Tooltip title="Duplicar">
                  <Button
                    style={buttonsStyle}
                    size="small"
                    onClick={() => {
                      setCursoId(elem);
                      setOpenConfirmDialog(4);
                    }}
                  >
                    <Copy />
                  </Button>
                </Tooltip>
                <Tooltip title={elem?.registroWeb ? "Editable" : "Protegido"}>
                  <Button
                    style={buttonsStyle}
                    size="small"
                    onClick={() => {
                      setCursoId(elem);
                      setOpenConfirmDialog(3);
                    }}
                  >
                    {elem?.registroWeb ? (
                      <LockOpen />
                    ) : (
                      <Lock style={{ color: "red" }} />
                    )}
                  </Button>
                </Tooltip>
                <Tooltip title={elem?.visible ? "Visible" : "Ocultar"}>
                  <Button
                    style={buttonsStyle}
                    size="small"
                    onClick={() => {
                      setCursoId(elem);
                      setOpenConfirmDialog(5);
                    }}
                  >
                    {elem?.visible ? (
                      <Eye />
                    ) : (
                      <EyeClosed style={{ color: "red" }} />
                    )}
                  </Button>
                </Tooltip>
                <Tooltip title={elem?.active ? "Disable" : "Enable"}>
                  <Button
                    style={buttonsStyle}
                    size="small"
                    onClick={() => {
                      setCursoId(elem);
                      setOpenConfirmDialog(1);
                    }}
                  >
                    {elem?.active ? (
                      <ToggleOffIcon />
                    ) : (
                      <ToggleOnIcon style={{ color: "red" }} />
                    )}
                  </Button>
                </Tooltip>
                <Tooltip title="Delete">
                  <Button
                    style={buttonsStyle}
                    size="small"
                    onClick={() => {
                      setCursoId(cell);
                      setOpenConfirmDialog(2);
                    }}
                  >
                    <DeleteIcon />
                  </Button>
                </Tooltip>
              </>
            )}
          </>
        )}
      </>
    );
  }

  // Formateador personalizado para fecha de inicio (solo fecha, sin hora)
  const fechaInicioFormatter = (cell) => {
    if (!cell) return "";

    let date = new Date(cell);
    if (isNaN(date.getTime())) return "";

    // Si el año es 1900, significa que venía null del origen
    if (date.getFullYear() === 1900) return "";

    // Formatear solo la fecha (sin hora)
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  };

  const plazasFormatter = (cell) => {
    return cell || "-";
  };

  const columns = [
    { dataField: "code", text: "Código Curso", sort: true },
    { dataField: "titulo", text: "Titulo", sort: true },
    {
      dataField: "plazasLibres",
      text: "Plazas libres/Completo",
      sort: true,
      formatter: plazasFormatter,
    },
    {
      dataField: "fechaIni",
      text: "Fecha Inicio",
      sort: true,
      formatter: fechaInicioFormatter,
    },
    { dataField: "id", text: "", formatter: buttonFormatter },
  ];

  useEffect(() => {
    getCursos()
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
          // Aplicar filtros guardados si existen
          const savedFilters = localStorage.getItem("cursosPageFilters");
          if (savedFilters) {
            const savedFilterOptions = JSON.parse(savedFilters);
            setFilterOptions(savedFilterOptions);
            // Aplicar filtros automáticamente
            const filtered = res.data.filter((item) => {
              let filter = true;
              if (savedFilterOptions.active) filter = filter && item.active;
              if (savedFilterOptions.isZoom !== null)
                filter = filter && item.isZoom === savedFilterOptions.isZoom;
              if (savedFilterOptions.fechaIniDesde) {
                const fechaIni = item.fechaIni ? new Date(item.fechaIni) : null;
                const fechaDesde = new Date(savedFilterOptions.fechaIniDesde);
                if (!fechaIni || fechaIni < fechaDesde) filter = false;
              }
              if (savedFilterOptions.fechaIniHasta) {
                const fechaIni = item.fechaIni ? new Date(item.fechaIni) : null;
                const fechaHasta = new Date(savedFilterOptions.fechaIniHasta);
                fechaHasta.setHours(23, 59, 59, 999);
                if (!fechaIni || fechaIni > fechaHasta) filter = false;
              }
              if (filter) return item;
              return false;
            });
            setFilteredData(filtered);
          } else {
            setFilteredData(res.data);
          }
          setRefresh(false);
        }
      })
      .catch((error) => {
        alertError({ error: error, customMessage: "Could not get cursos." });
      });
  }, [refresh]);

  const handleSearch = async () => {
    if (!data.length) return;
    // Guardar filtros en localStorage
    localStorage.setItem("cursosPageFilters", JSON.stringify(filterOptions));
    setFilteredData(
      data.filter((item) => {
        let filter = true;
        if (filterOptions.active) filter = filter && item.active;
        if (filterOptions.isZoom !== null)
          filter = filter && item.isZoom === filterOptions.isZoom;
        if (filterOptions.fechaIniDesde) {
          const fechaIni = item.fechaIni ? new Date(item.fechaIni) : null;
          const fechaDesde = new Date(filterOptions.fechaIniDesde);
          if (!fechaIni || fechaIni < fechaDesde) filter = false;
        }
        if (filterOptions.fechaIniHasta) {
          const fechaIni = item.fechaIni ? new Date(item.fechaIni) : null;
          const fechaHasta = new Date(filterOptions.fechaIniHasta);
          fechaHasta.setHours(23, 59, 59, 999);
          if (!fechaIni || fechaIni > fechaHasta) filter = false;
        }
        if (filter) return item;
        return false;
      }),
    );
  };

  const handleClearFilters = () => {
    setFilterOptions(initialFilters);
    setSearchText("");
    localStorage.removeItem("cursosPageFilters");
    localStorage.removeItem("cursosPage_searchText");
    localStorage.removeItem("cursosPage_currentPage");
    setRefresh(true);
  };

  const renderFiltersContent = () => {
    return (
      <div style={{ padding: "15px 0 0 0" }}>
        {/* Primera fila: Filtros en grid organizado - alineados por abajo */}
        <div className="row align-items-end">
          <div className="col-md-3 col-sm-6 mb-3">
            <TextField
              id="search"
              label="Buscar"
              placeholder="Buscar en todos los campos..."
              value={searchText}
              onChange={(e) => handleTableSearchChange(e.target.value)}
              margin="dense"
              variant="outlined"
              fullWidth
              style={{ marginTop: 0, marginBottom: 0 }}
            />
          </div>
          <div className="col-md-3 col-sm-6 mb-3">
            <label
              style={{
                display: "block",
                marginBottom: "8px",
                fontWeight: 500,
                fontSize: "14px",
                color: "#333",
              }}
            >
              Zoom
            </label>
            <Select
              value={
                filterOptions.isZoom !== null
                  ? {
                      value: filterOptions.isZoom,
                      label: filterOptions.isZoom ? "Sí" : "No",
                    }
                  : null
              }
              onChange={(selected) =>
                setFilterOptions({
                  ...filterOptions,
                  isZoom: selected ? selected.value : null,
                })
              }
              options={[
                { value: true, label: "Sí" },
                { value: false, label: "No" },
              ]}
              placeholder="Todos"
              isClearable
              styles={{
                control: (provided) => ({
                  ...provided,
                  minHeight: "40px",
                  borderColor: "#ced4da",
                }),
                menu: (provided) => ({ ...provided, zIndex: 9999 }),
              }}
            />
          </div>

          <div className="col-md-3 col-sm-6 mb-3">
            <TextField
              id="fechaIniDesde"
              label="Fecha Inicio Desde"
              type="date"
              value={filterOptions.fechaIniDesde || ""}
              onChange={(e) =>
                setFilterOptions({
                  ...filterOptions,
                  fechaIniDesde: e.target.value,
                })
              }
              InputLabelProps={{ shrink: true }}
              margin="dense"
              variant="outlined"
              fullWidth
              style={{ marginTop: 0, marginBottom: 0 }}
            />
          </div>

          <div className="col-md-3 col-sm-6 mb-3">
            <TextField
              id="fechaIniHasta"
              label="Fecha Inicio Hasta"
              type="date"
              value={filterOptions.fechaIniHasta || ""}
              onChange={(e) =>
                setFilterOptions({
                  ...filterOptions,
                  fechaIniHasta: e.target.value,
                })
              }
              InputLabelProps={{ shrink: true }}
              margin="dense"
              variant="outlined"
              fullWidth
              style={{ marginTop: 0, marginBottom: 0 }}
            />
          </div>
        </div>

        {/* Switches y botones de acción en la misma línea */}
        <div className="row">
          <div className="col-12">
            <div
              className="d-flex justify-content-between align-items-center flex-wrap"
              style={{ marginTop: "10px", marginBottom: "10px", gap: "15px" }}
            >
              {/* Switches a la izquierda */}
              <div
                className="d-flex align-items-center flex-wrap"
                style={{ gap: "30px" }}
              >
                <FormControlLabel
                  control={
                    <Switch
                      checked={filterOptions.active}
                      onChange={() =>
                        setFilterOptions({
                          ...filterOptions,
                          active: !filterOptions.active,
                        })
                      }
                      name="checkActive"
                      style={{ color: "#f3691a" }}
                    />
                  }
                  label={
                    filterOptions.active
                      ? "Solo activos"
                      : "Todos (activos/inactivos)"
                  }
                  style={{ margin: 0 }}
                />
              </div>
              {/* Botones a la derecha */}
              <div className="d-flex">
                <Button
                  variant="contained"
                  onClick={handleSearch}
                  startIcon={<SearchIcon />}
                  style={{
                    minWidth: "120px",
                    backgroundColor: "#f3691a",
                    color: "#fff",
                    marginRight: "10px",
                  }}
                >
                  Buscar
                </Button>
                <Button
                  variant="outlined"
                  onClick={handleClearFilters}
                  startIcon={<FilterOffIcon />}
                  style={{
                    minWidth: "120px",
                    borderColor: "#f3691a",
                    color: "#f3691a",
                  }}
                >
                  Limpiar
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <Card>
        <CardHeader title="Lista de cursos">
          <CardHeaderToolbar>
            <Button
              variant="contained"
              onClick={() => history.push("/edit-curso")}
              startIcon={<AddIcon />}
              style={{
                backgroundColor: "#f3691a",
                color: "#fff",
              }}
            >
              Añadir nuevo
            </Button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          {/* Filtros siempre visibles con mejor diseño */}
          <Card style={{ marginBottom: "15px", backgroundColor: "#f8f9fa" }}>
            <CardBody style={{ padding: "15px 20px" }}>
              {renderFiltersContent()}
            </CardBody>
          </Card>

          {!refresh && (
            <Table
              data={getData(filteredData)}
              columns={columns}
              pageKey="cursosPage"
              searchText={searchText}
              onSearchChange={handleTableSearchChange}
            />
          )}

          <ConfirmDialog
            title={`Are you sure you want to ${
              cursoId?.active ? "disable" : "enable"
            } this curso?`}
            open={openConfirmDialog === 1}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              changeStatusCurso(cursoId._id, !cursoId?.active)
                .then((res) => {
                  if (res.status === 200) {
                    alertSuccess({
                      title: `${cursoId?.active ? "Disabled!" : "Enabled!"}`,
                      customMessage: `User type ${
                        cursoId?.active ? "disabled" : "enabled"
                      } successfully`,
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: `Could not ${
                      cursoId?.active ? "disable" : "enable"
                    } curso.`,
                  });
                });
            }}
          />
          <ConfirmDialog
            title={"Are you sure you want to remove this curso?"}
            open={openConfirmDialog === 2}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              deleteCurso(cursoId)
                .then((res) => {
                  if (res.status === 204 || res.status === 200) {
                    alertSuccess({
                      title: "Deleted!",
                      customMessage: "Curso removed successfully.",
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: "Could not remove curso.",
                  });
                });
            }}
          />
          <ConfirmDialog
            title={`Estas seguro que quieres ${
              cursoId?.registroWeb ? "Protejer" : "Editable"
            } el registro de este curso?`}
            open={openConfirmDialog === 3}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              changeStatusRegistroCurso(cursoId._id, !cursoId?.registroWeb)
                .then((res) => {
                  if (res.status === 200) {
                    alertSuccess({
                      title: `${
                        cursoId?.registroWeb ? "Editable!" : "Despublicar!"
                      }`,
                      customMessage: `Curso ${
                        cursoId?.registroWeb ? "Editable" : "despublicar"
                      }`,
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: `Could not ${
                      cursoId?.registroWeb ? "publicar" : "despublicar"
                    } curso.`,
                  });
                });
            }}
          />
          <ConfirmDialog
            title={`Estas seguro que quieres duplicar el registro de este curso?`}
            open={openConfirmDialog === 4}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              duplicarCurso(cursoId._id, cursoId)
                .then((res) => {
                  if (res.status === 201) {
                    alertSuccess({
                      title: `Duplicado`,
                      customMessage: `Curso duplicado`,
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: `No se ha podido duplicar el curso.`,
                  });
                });
            }}
          />
          <ConfirmDialog
            title={`Estas seguro que quieres ${
              cursoId?.visible ? "despublicar" : "publicar"
            } curso en la web?`}
            open={openConfirmDialog === 5}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              changeVisibleCurso(cursoId._id, !cursoId?.visible)
                .then((res) => {
                  if (res.status === 200) {
                    alertSuccess({
                      title: `${
                        cursoId?.visible ? "Publicado!" : "Protegido!"
                      }`,
                      customMessage: `Curso ${
                        cursoId?.visible ? "Publicado" : "protegido"
                      }`,
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: `Could not ${
                      cursoId?.visible ? "hacer editable" : "proteger"
                    } curso.`,
                  });
                });
            }}
          />
        </CardBody>
      </Card>
    </>
  );
}
